var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5c-5.554 0-10.172 4.027-11.086 9.328a6.798 6.798 0 012.088-.33h1.124a3.375 3.375 0 013.375 3.374v6.748a3.375 3.375 0 01-3.374 3.375h-1.125a6.75 6.75 0 01-6.749-6.749v-4.5C4.253 9.052 11.304 2 20 2s15.747 7.051 15.747 15.747v11.817c0 4.661-3.782 8.436-8.443 8.436l-6.18-.007h-2.249a3.375 3.375 0 010-6.749h2.25a3.375 3.375 0 013.374 3.375h2.812a5.058 5.058 0 005.062-5.062v-1.47c-.992.577-2.145.9-3.375.9h-1.125a3.375 3.375 0 01-3.374-3.374v-6.748a3.375 3.375 0 013.374-3.375h1.125c.731 0 1.427.113 2.088.33-.914-5.293-5.525-9.328-11.086-9.328V6.5z"
  })));
}
export default SvgHeadset;